import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { MasterDataSimpleResource, SimulationSoftwareVersionResource } from '@shared/openapi/business';
import { OccurrenceUnit } from '@shared/models/occurrence-unit';

const STORAGE_KEY = 'userPreferences';

export interface Software extends MasterDataSimpleResource {
  versions: SimulationSoftwareVersionResource[];
}

interface UserPreferencesDialogState {
  language: string;
  softwares: Software[];
  showDescription: boolean;
  showOccurenceRate: boolean;
  units: string | undefined;
}

const initialState: UserPreferencesDialogState = {
  language: 'en',
  softwares: [],
  showDescription: true,
  showOccurenceRate: true,
  units: OccurrenceUnit.KILOMETER,
};

export const UserPreferencesDialogStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withMethods((store) => {
    // Load preferences from localStorage
    function loadPreferences() {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const preferences = JSON.parse(stored);
        if (preferences.units === '1000km') {
          preferences.units = OccurrenceUnit.KILOMETER;
        }
        patchState(store, preferences);
      }
    }

    // Update a preference and save
    function setPreference(preferences: Partial<UserPreferencesDialogState>) {
      patchState(store, preferences);
      const fullState: UserPreferencesDialogState = {
        language: store.language(),
        softwares: store.softwares(),
        showDescription: store.showDescription(),
        showOccurenceRate: store.showOccurenceRate(),
        units: store.units(),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(fullState));
    }

    // Reset all preferences
    function clearPreferences(): void {
      patchState(store, initialState);
      localStorage.removeItem(STORAGE_KEY);
    }

    return {
      loadPreferences,
      setPreference,
      clearPreferences,
    };
  }),

  withHooks({
    onInit(store) {
      store.loadPreferences();
    },
  }),
);
